export default __webpack_public_path__ + "static/media/invalid.5ec5eae9.png";